
export const calculateTeamCards = (matches: any[], isHome?: boolean) => {
  let totalCards = 0;
  const teamStats = new Map<string, { total: number; games: number }>();
  const thresholds = [0.5, 1.5, 2.5, 3.5, 4.5, 5.5, 6.5];
  const overUnderCounts = thresholds.map(threshold => ({
    threshold,
    overCount: 0,
    underCount: 0
  }));

  matches.forEach(match => {
    let matchCards = 0;
    
    if (isHome === true) {
      const yellow = parseInt(match.HY || '0');
      const red = parseInt(match.HR || '0');
      matchCards = yellow + red;
      totalCards += matchCards;
      const team = match.HomeTeam;
      if (!teamStats.has(team)) {
        teamStats.set(team, { total: 0, games: 0 });
      }
      const stats = teamStats.get(team)!;
      stats.total += matchCards;
      stats.games += 1;
    } else if (isHome === false) {
      const yellow = parseInt(match.AY || '0');
      const red = parseInt(match.AR || '0');
      matchCards = yellow + red;
      totalCards += matchCards;
      const team = match.AwayTeam;
      if (!teamStats.has(team)) {
        teamStats.set(team, { total: 0, games: 0 });
      }
      const stats = teamStats.get(team)!;
      stats.total += matchCards;
      stats.games += 1;
    } else {
      const homeYellow = parseInt(match.HY || '0');
      const homeRed = parseInt(match.HR || '0');
      const awayYellow = parseInt(match.AY || '0');
      const awayRed = parseInt(match.AR || '0');
      matchCards = homeYellow + homeRed + awayYellow + awayRed;
      totalCards += matchCards;
      
      const homeTeam = match.HomeTeam;
      if (!teamStats.has(homeTeam)) {
        teamStats.set(homeTeam, { total: 0, games: 0 });
      }
      const homeStats = teamStats.get(homeTeam)!;
      homeStats.total += homeYellow + homeRed;
      homeStats.games += 1;

      const awayTeam = match.AwayTeam;
      if (!teamStats.has(awayTeam)) {
        teamStats.set(awayTeam, { total: 0, games: 0 });
      }
      const awayStats = teamStats.get(awayTeam)!;
      awayStats.total += awayYellow + awayRed;
      awayStats.games += 1;
    }

    overUnderCounts.forEach(count => {
      if (matchCards > count.threshold) {
        count.overCount++;
      } else {
        count.underCount++;
      }
    });
  });

  let mostCards = { team: '', average: 0 };
  let leastCards = { team: '', average: Infinity };

  teamStats.forEach((stats, team) => {
    const average = stats.total / stats.games;
    if (average > mostCards.average) {
      mostCards = { team, average };
    }
    if (average < leastCards.average) {
      leastCards = { team, average };
    }
  });

  const totalGames = matches.length;
  const average = (totalCards / totalGames).toFixed(2);

  const overUnderStats = overUnderCounts.map(({ threshold, overCount }) => ({
    threshold,
    over: ((overCount / totalGames) * 100).toFixed(1),
    under: (((totalGames - overCount) / totalGames) * 100).toFixed(1)
  }));

  return {
    totalCards,
    average,
    mostCards,
    leastCards,
    overUnderStats
  };
};
